export const getUsedTens = (usedBytes: number, totalBytes: number): number | 'over' => {
    if (usedBytes === totalBytes) {
        return 100;
    }

    const usedTens = Math.floor((10 * usedBytes) / totalBytes) * 10;
    return usedTens < 100 ? usedTens : 'over';
};
